import { render, staticRenderFns } from "./ResponsiveCardSelector.vue?vue&type=template&id=c33e6fe4&scoped=true"
import script from "./ResponsiveCardSelector.vue?vue&type=script&lang=js"
export * from "./ResponsiveCardSelector.vue?vue&type=script&lang=js"
import style0 from "./ResponsiveCardSelector.vue?vue&type=style&index=0&id=c33e6fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33e6fe4",
  null
  
)

export default component.exports